exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.price-info[data-v-5398138a] {\r\n    border-radius: 8px;\r\n    padding: 6px;\r\n    border: 1px solid #3172DF;\r\n    background-color: #3172DF1A;\r\n\r\n    display: -ms-flexbox;\r\n\r\n    display: flex;\r\n    column-gap: 8px;\n}\n.price-info p[data-v-5398138a]{\r\n    margin: 0;\n}\n.price-info svg[data-v-5398138a] {\r\n    -ms-flex: 0 0 24px;\r\n        flex: 0 0 24px;\r\n    width: 24px;\r\n    height: 24px;\n}\n.open-disclaimer-btn[data-v-5398138a] {\r\n    display: inline-block;\r\n    padding: 0;\r\n    font-weight: 700;\r\n    color: #3172DF;\r\n    background-color: transparent;\r\n    border: none;\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-5398138a","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./scripts/src/components/inventory/price-info.vue
// module id = 609
// module chunks = 0